module.exports = __webpack_public_path__ + "static/img/s_banner2.164d8039.jpg";